import React, { Component } from 'react';
import { connect } from "react-redux";
import { highFives } from "../../redux/selectors";
import { sortArray } from '../assets/util';
import ProfilePic from '../atoms/profilePic/profilePic';
import EmptyState from '../molecules/emptyState/emptyState';
import SideModal from '../molecules/modal/sideModal';
import { ListCommunication } from '../molecules/listItems/listItems';

class HighFives extends Component {
  renderList() {
    const highFives = this.props.highFives;
    if(highFives && highFives.length > 0) {
      let highFivesSorted = sortArray(highFives);
      return highFivesSorted.map((highFive, key) => {
        let sender = this.props.employees.find(employee => employee.uid === highFive.sender);
        return <ListCommunication key={key} sender={sender} highFive={highFive} />
      })
    } else {
      return <EmptyState title='Help others to receive high fives!' text='Motivate co-workers by telling them they did a good job. Add an high five yourself on the homescreen, and who knows, others might do the same for you!' />
    }
  }
  render() {
    const { highFives, state } = this.props
    return (
      <SideModal active={state ? 'active' : null } screen='highFives' >
        <div id='sideModalWrapper'>
          <h1>High fives!</h1>
          <div className='highFiveList'>
            {this.renderList()}
          </div>

        </div>
      </SideModal>
    )
  }
}

function mapStateToProps(state) {
  return {
    highFives: highFives(state),
    employees: state.employees,
    state: state.overlays.highFives
  };
}

export default connect(mapStateToProps)(HighFives);
